import React from 'react';
import PropTypes from 'prop-types';
import { isTablet } from '../../../utils/adaptive';
import ScrollManager from '../../../utils/scrollManager';
import Tab from './city-tab';
import {
  TabContainer, Placeholder, Dropdown, DropdownParent, DropdownContainer,
} from '../styles/city-selector.style';

const propTypes = {
  teams: PropTypes.array,
  selectTeam: PropTypes.func,
  keyboardSelect: PropTypes.func,
  layout: PropTypes.string,
  ticketSelector: PropTypes.bool,
};

const defaultProps = {
  teams: [
    {
      node: {},
    },
  ],
  selectTeam: () => {},
  keyboardSelect: () => {},
  layout: '',
  ticketSelector: false,
};

/**
 * Title Component
 * @param {object} props Incoming props
 * @returns {XML} A title component
 */
class SelectTeam extends React.Component {
  /**
   *
   * @param {*} props Passed from parent component
   */
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      showDropdown: false,
      minimized: false,
    };
  }

  /**
   * Determine if mobile components should be used
   */
  componentDidMount() {
    if (isTablet()) {
      this.setState({ isMobile: true });
    } else {
      ScrollManager.addOnScroll(() => {
        if (window) {
          if (window.pageYOffset > window.outerHeight / 5) {
            this.setState({ minimized: true });
          }
          if (window.pageYOffset < window.outerHeight / 5) {
            this.setState({ minimized: false });
          }
        }
      });
    }
  }

  /**
   * Toggle dropdown
   */
  toggleDropdown() {
    this.setState(prevState => ({
      showDropdown: !prevState.showDropdown,
    }));
  }

  /**
   * Renders the component
   * @returns {XML} A team selection component
   */
  render() {
    const {
      teams, selectTeam, activeIndex, expanded, ticketSelector,
    } = this.props;
    const { isMobile, showDropdown, minimized } = this.state;
    const tabs = [];
    for (let i = 0; i < teams.length; i++) {
      tabs.push(
        <Tab
          key={i}
          index={i}
          isActive={activeIndex === i}
          select={() => {
            selectTeam(i);
            if (showDropdown) {
              this.toggleDropdown();
            }
          }}
          {...teams[i].node}
          expanded={expanded}
          mobile={isMobile}
          minimized={minimized}
          ticketSelector={ticketSelector}
        />,
      );
    }
    if (isMobile) {
      const expandedClassName = expanded ? 'expanded' : '';
      const openClassName = showDropdown ? 'open' : '';

      return (
        <DropdownParent>
          <Dropdown onClick={() => this.toggleDropdown()} className={expandedClassName}>
            <p>
              {typeof activeIndex === 'number' && activeIndex >= 0 && teams[activeIndex].node
                ? `${teams[activeIndex].node.cityName} ${teams[activeIndex].node.teamName || ''}` : 'Choose A City'}
            </p>
            <img src="/images/carat.png" alt="" className={openClassName} />
          </Dropdown>
          <DropdownContainer className={`${expandedClassName} ${openClassName}`}>
            {tabs}
          </DropdownContainer>
          <TabContainer />
        </DropdownParent>
      );
    }
    if (expanded) {
      return (
        <div ref={this.ref}>
          <Placeholder className={minimized && 'minimized'} />
          <TabContainer className={`expanded ${minimized && 'minimized'}`}>{tabs}</TabContainer>
        </div>
      );
    }
    return <TabContainer className="collapsed">{tabs}</TabContainer>;
  }
}

SelectTeam.propTypes = propTypes;
SelectTeam.defaultProps = defaultProps;

export default SelectTeam;



// WEBPACK FOOTER //
// ./src/components/city-selector/components/city-selector.js